import dayjs from 'dayjs';

export const requiresProbationEndDate = (jobStatus) => jobStatus === 'Probation';

export const getAutoProbationEndDate = ({ jobStatus, joinDate, jobExpiryDate }) => {
    if (!requiresProbationEndDate(jobStatus) || !joinDate || jobExpiryDate) {
        return null;
    }

    return dayjs(joinDate).add(3, 'months');
};
